import React from "react";
import { Button } from "@mui/material";
import { Link as LinkIcon } from "@mui/icons-material";
import { useLink } from "decodable-ui/lib/components/LinkContext";
import { useActiveAccount } from "../accounts/hooks/useAccounts";

export default function HomeButton({ text = "Go home" }) {
  const Link = useLink();
  const { activeAccount } = useActiveAccount();

  return (
    <Button
      component={Link}
      href={`/${activeAccount?.name ?? ""}`}
      variant="contained"
      color="primary"
    >
      {text}
      <LinkIcon sx={{ marginLeft: 1, fontSize: "1.5em" }} />
    </Button>
  );
}
